import { render, staticRenderFns } from "./ImportanceSlider.vue?vue&type=template&id=3cd39d9a&scoped=true&"
import script from "./ImportanceSlider.vue?vue&type=script&lang=js&"
export * from "./ImportanceSlider.vue?vue&type=script&lang=js&"
import style0 from "./ImportanceSlider.vue?vue&type=style&index=0&id=3cd39d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd39d9a",
  null
  
)

export default component.exports